import React, { FC, PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';

import { Checkbox } from '@portal/common/components';

import { isForecastingData as getIsForecastingData } from '../../../../store/data-explorer/selectors';
import { checkIsDengueDataTool } from '../../../../store/user-settings/selectors';

type DisplayForecastsCheckboxProps = PropsWithChildren<any> & {
    checked: boolean;
    onChange?: (ev: any) => void;
    label: string;
};

const ShowForecastsCheckbox: FC<DisplayForecastsCheckboxProps> = ({
    checked,
    onChange,
    children,
    ...props
}) => {
    const isForecastingData = useSelector(getIsForecastingData);
    const isDengue = useSelector(checkIsDengueDataTool);

    if (!isForecastingData || isDengue) return null;

    return (
        <Checkbox checked={checked} onChange={onChange} {...props}>
            {children}
        </Checkbox>
    );
};

export default ShowForecastsCheckbox;
